import * as React from 'react'
import { WalletPaymentButton } from '@lacedltd/laced-components'
import { withTranslations } from 'helpers'
import { useTranslation } from 'hooks'
import * as S from './CustomPaymentButton.styles'

const CustomPaymentButton: React.FC<CustomPaymentButtonProps> = ({
  clickHandler,
  errorMsg,
  availableMethod,
  isAvailable,
  loading,
  isPdp
}) => {
  const { t } = useTranslation()
  const show = isAvailable || loading

  return show ? (
    <S.CustomPaymentButtonWrapper loading={loading} role="button">
      <WalletPaymentButton
        onClick={clickHandler}
        availableMethod={availableMethod}
        loading={loading}
        variant={isPdp ? 'light' : 'dark'}
      >
        {t('react_components.wallet_pay.buy_with')}
      </WalletPaymentButton>
      {errorMsg ? (
        <S.ErrorMessage as="span" variant="footnote">
          {errorMsg}
        </S.ErrorMessage>
      ) : null}
    </S.CustomPaymentButtonWrapper>
  ) : null
}

export interface CustomPaymentButtonProps {
  clickHandler: () => void
  errorMsg: string | undefined
  availableMethod: Record<string, boolean> | null
  isAvailable: boolean
  loading: boolean
  isPdp: boolean
}

export default withTranslations(CustomPaymentButton)
